const apiVersion = "v1";
const apiName = "/verve-life-admin/api";
const dealsApiURI = "/vervelife-deals-admin/api/v1";
const foodApiUrl = "/vervelife-fitness-admin/api/v1";
const baseUrl = `${apiName}/${apiVersion}`;

export const apiUrls = {
    interests: {
        base: `${baseUrl}/interests`,
        instructor: `${baseUrl}/interests/instructor`,
    },
    activities: {
        base: `${baseUrl}/activities`,
    },
    categories: {
        base: `${baseUrl}/categories`,
    },
    instructors: {
        base: `${baseUrl}/instructors`,
    },
    getUser: {
        user: `/api/v1/user`,
        permissions: `/api/v1/user/permissions`,
    },
    posts: {
        base: `${baseUrl}/posts`,
        draft: `${baseUrl}/posts/drafts`,
        data: `${baseUrl}/reports/posts`,
        review: `${baseUrl}/posts/review`,
        revise: `${baseUrl}/posts/revise/`,
        postFrequency: `${baseUrl}/settings/updatepostfrequency`,
        showPostCycle: `${baseUrl}/settings/postfrequency`,
        uploadImage: `${baseUrl}/posts/upload-image`,
        unApprovePost: `${baseUrl}/posts/unapprove`,
    },
    events: {
        base: `${baseUrl}/events`,
        attendees: `${baseUrl}/events/attendees`,
    },
    metrics: {
        base: `${baseUrl}/metrics`,
    },
    banners: {
        base: `${baseUrl}/ads`,
    },
    deals: {
        base: `${dealsApiURI}/deals`,
        categories: `${dealsApiURI}/categories`,
    },
    merchants: {
        base: `${dealsApiURI}/merchants`,
    },
    food: {
        library: `${foodApiUrl}/libraries/food-items`,
        mealPlan: `${foodApiUrl}/libraries/meal-plans`,
        configs: `${foodApiUrl}/services/configs/plans`,
        foodMeasures: `${foodApiUrl}/services/food-measures`,
    },
};
